<script lang="ts">
	import { getHubStores } from '$lib/stores/hubStores';
	import { onDestroy } from 'svelte';
	import Notification from './Notification.svelte';
	import ButtonLink from '$lib/components/ButtonLink/ButtonLink.svelte';
	import { _ } from 'svelte-i18n';
	import { notifications } from '$lib/stores/notificationStore';
	import { page } from '$app/stores';

	const { hub, restApi } = getHubStores();

	export let setSettingsActive: () => void;

	onDestroy(async () => {
		if ($notifications.length > 0) {
			const lastNotification = $notifications[$notifications.length - 1];
			await restApi.dismissNotifications($hub.id, lastNotification.id);
			$notifications = [];
		}
	});

	const notificationsLink = `${$page.url.origin}/${$page.params.hubPrefix}/notifications` as const;
</script>

<div class={`menu`}>
	<div class="notificationTitle">
		{$_('session.activitylist.notifications.heading')}
		<a href={notificationsLink} class="notificationsLink">See all</a>
	</div>
	{#if $notifications.length > 0}
		<div class="notificationsContainer">
			{#each $notifications as notification}
				<Notification {notification} />
			{/each}
		</div>
	{:else}
		<div class="notificationsContainer noNew">{$_('session.activities.empty')}</div>
	{/if}
	<div class="settings">
		<ButtonLink on:click={setSettingsActive}>
			{$_('notification.settings.header')}
		</ButtonLink>
	</div>
</div>

<style>
	.menu {
		display: flex;
		flex-direction: column;
		block-size: auto;
	}

	.menu > * {
		color: var(--secondaryHeadlineColor);
		font-size: var(--fontSizeSmall);
		font-weight: 500;
		user-select: none;
	}

	.notificationsContainer {
		max-block-size: 360px;
		inline-size: 300px;
		padding-inline: var(--gutterSubMedium);
		overflow: auto;
		border-block-start: 1px solid var(--grayLighter);
		border-block-end: 1px solid var(--grayLighter);
	}

	@media only screen and (max-width: 500px) {
		.notificationsContainer {
			inline-size: 70vw;
		}
	}

	.noNew {
		padding-block: var(--gutterMedium);
		text-align: center;
	}

	.notificationTitle {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: var(--gutterMedium);
	}

	.settings {
		padding: var(--gutterMedium);
		text-align: center;
	}

	:global(.settings > button) {
		color: var(--BLACK) !important;
		font-size: var(--fontSizeSmall);
	}

	.notificationsLink {
		color: #1556b1;
	}
</style>
